<template>
    <div class="files">
        <ul class="files__list display--flex">
            <li
                v-for="( file, index ) in settings.files"
                :key="`file-${index}`"
                class="files__list__file position--relative pointer"
                :class="{ 'disable': loading }"
                aria-role="button"
                @click="exportsFiles( file.url )"
                @click.middle="exportsFiles( file.url )"
            >
                <span class="files__list__file__name">{{ file.alias }}</span>
                <span @click.stop="deleteFile.actions.open({ modalName: 'deleteFile', file })" class="files__list__file__remove pointer"></span>
            </li>
        </ul>
        <a class="download" download></a>

        <!-- modal de confirmação para forçar o update do guião -->
        <modal
            v-if="deleteFile.show"
            :form="{
                class: 'modal__confirmation--delete-file'
            }"
            :customSettings="{
                position: 'center',
                button: {
                    label: 'remove',
                    type: 'button',
                    action: () => deleteFile.actions.submit()
                }
            }"
            @close="deleteFile.actions.close( 'deleteFile' )"
            :key="deleteFile.show"
        >
            <template #modal__header >
                <h2 class="modal__confirmation--delete-file__header">{{ $t('global.deleteAttachment') }}</h2>
            </template>
            <template #modal__body__confirm >
                <span class="modal__confirmation--delete-file__info display--block capitalize">
                    {{ $t('global.areYouSureYouWantTo') + $t('warning.deleteThisFile') + ' ?'}}
                </span>
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    @click.prevent="deleteFile.actions.close( 'deleteFile' )"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
    </div>
</template>

<script>
// Mixins
import exportFiles from '@/helpers/exportFiles';

// packages
import { reactive, toRefs } from '@vue/composition-api';

// store
import { useStore } from '@/hooks/use-store';

// requests
import { deleteRequest } from '@/helpers/requests';

// i18n
import i18n from '@/plugins/i18n';

export default {
    mixins: [ exportFiles ],
    components: {
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        settings: Object
    },
    setup ( props, { emit }) {
        const { actions } = useStore();

        // Fecho do modal e reset das settings.
        const closeModal = modalName => {
            modals[modalName].show = false;
            modals[modalName].settings = {};
        };

        // Abertura do modal e definição das settings.
        const openModal = ({ modalName, file }) => {
            modals[modalName].show = true;
            modals[modalName].settings = { ...file };
        };

        // Remoção de ficheiro.
        const removeFile = async () => {
            const endpoint = modals.deleteFile.settings.url;
            const endpointSplit = endpoint.split( '/' );
            const { files, ...otherParams } = props.settings;

            actions( 'toggleLoading' );
            const response = await deleteRequest( endpoint, {
                data: {
                    id: parseInt( endpointSplit[endpointSplit.length - 1], 10 ),
                    ...( otherParams.templateId && { template_id: otherParams.templateId })
                }
            })
                .then( ({ data }) => ({
                    has: true,
                    type: 'success',
                    message: data.message,
                    content: data.content.data
                }) )
                .catch( error => ({
                    has: true,
                    type: 'insuccess',
                    message: error.message,
                    errors: error?.content?.errors || i18n.t( 'error.request' )
                }) );
            // procedimento no final da submissão
            actions( 'finalSubmission', response );

            // Se for eliminado com sucesso, é emitido o url do ficheiro eliminado
            // para o componente pai, para poder ser eliminado da lista de files.
            if ( response.has && response.type === 'success' )
                emit( 'deleteFile', modals.deleteFile.settings.url );

            closeModal( 'deleteFile' );
        };

        const modals = reactive({
            deleteFile: {
                show: false,
                actions: {
                    close: closeModal,
                    open: openModal,
                    submit: removeFile
                },
                settings: {
                    file: {}
                }
            }
        });

        return {
            ...toRefs( modals )
        };
    }
};
</script>

<style lang="scss">
    .files {
        &__list {
            gap: 10px;
            flex-wrap: wrap;
            &__file {
                @include rounded-corner( 5px );
                @include  element-border( $color-green );
                @include elements-colors ( none, $color-green );
                @include typography-specs( 14px, unset );
                @include sentence-cut();
                padding: 5px 33px 5px 5px;
                @include transition( all .3s ease-in-out );
                &:hover {
                    text-decoration: underline;
                }
                &__remove {
                    position: absolute;
                    right: 5px;
                    top: 11px;
                    width: 32px;
                    @include transition( background-color .3s ease-in-out );
                    &:before, &:after {
                        position: absolute;
                        right: 11px;
                        content: ' ';
                        height: 15px;
                        width: 2px;
                        background-color: $color-green;
                    }
                    &:before {
                        transform: rotate(45deg);
                    }
                    &:after {
                        transform: rotate(-45deg);
                    }
                }
            }
        }
    }
</style>